import { useEffect } from 'react';
import { startAppBannerSessionHeartbeat } from '../lib/appBannerSession';

/**
 * GROWTH-01 — keeps the web-to-app banner's session alive while any page is
 * open. Renders nothing; does nothing during SSR (the effect is client-only).
 *
 * Mounted once in src/pages/+Layout.tsx, next to the GA4 page-view tracker and
 * for the same reason: the layout sits above both client routers, so this runs
 * on every route the web app can render. See `startAppBannerSessionHeartbeat`
 * for what a session is and why the heartbeat has to be app-wide.
 */
export default function AppBannerSessionHeartbeat(): null {
  useEffect(() => startAppBannerSessionHeartbeat(), []);
  return null;
}
